import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/ef8ea1dddeff8b6bbb996826da72a67c.jpg"
          alt="Agricultural Export Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      {/* Hero Content */}
      <div className="relative z-10 w-full px-4 sm:px-6 md:px-8 py-20 sm:py-24 md:py-32 flex flex-col justify-center min-h-screen">
        <div className="max-w-7xl mx-auto w-full">
          <div className="max-w-3xl">
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-bold text-white leading-tight mb-4 sm:mb-6">
              Global Trade
              <br />
              <span className="text-emerald-400">Excellence</span> in
              <br />
              Agricultural Exports
            </h1>
            <p className="text-base sm:text-lg md:text-xl text-gray-200 mb-6 sm:mb-8 md:mb-10 max-w-2xl">
              Premium quality pulses, spices, rice, maize, coffee and tea powder delivered worldwide with unmatched reliability
            </p>
            <div className="flex flex-col sm:flex-row flex-wrap gap-3 sm:gap-4">
              <Link to="/products" className="px-6 sm:px-8 py-3 sm:py-4 bg-emerald-500/90 text-white rounded-full text-sm sm:text-base font-semibold hover:bg-emerald-600 transition-all whitespace-nowrap cursor-pointer text-center">
                Explore Products
              </Link>
              <Link to="/contact" className="px-6 sm:px-8 py-3 sm:py-4 border-2 border-white text-white rounded-full text-sm sm:text-base font-semibold hover:bg-white hover:text-emerald-600 transition-all whitespace-nowrap cursor-pointer text-center">
                Request Catalog
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
